import { useRouter } from 'next/router'

import { selectExperiment } from '@/redux/slices/statsig'
import { useAppSelector } from '@/redux/store/hooks'

import { SRP_REVAMP_EXPERIMENTS, SRP_REVAMP_LEGACY_COOKIE } from '@/constants/flights/srpRevamp'
import useVariant from '@/hooks/statsig/useVariant'
import { isServer } from '@/utils/general'
import { getCookie } from '@/utils/general/cookie'

const useSrpRevampExperiment = () => {
  const router = useRouter()
  // Same derivation as getProcessedData: international has its own route, and the
  // shared route carries intl=y.
  const isIntl = !!router?.route?.includes('international') || router?.query?.intl === 'y'
  const isCfw = router?.query?.isCfw === 'true'
  const experiment = isIntl ? SRP_REVAMP_EXPERIMENTS.intl : SRP_REVAMP_EXPERIMENTS.dom

  const { variant: clientVariant, loading } =
    useVariant({
      experiment: experiment.experimentName,
      cookieValue: experiment.cookieName,
      experimentParameter: experiment.experimentParameter,
      defaultVariant: experiment.controlVariant,
    }) || {}

  const reduxVariant = useAppSelector(selectExperiment(experiment.experimentName))

  const cookieVariant = isServer()
    ? ''
    : getCookie(experiment.cookieName) || getCookie(SRP_REVAMP_LEGACY_COOKIE)

  let variant: string = experiment.controlVariant
  if (cookieVariant) {
    variant = cookieVariant
  } else if (reduxVariant) {
    variant = reduxVariant
  } else if (!loading && clientVariant) {
    variant = clientVariant
  }

  return {
    variant,
    loading,
    // CFW stays on the old experience whatever the experiment says.
    isSrpRevamp: !isCfw && variant === experiment.testVariant,
  }
}

export default useSrpRevampExperiment
